import {
	DisplayUtils,
	ITEM_FAVORITE_TYPE,
	ItemService,
	TItemLabelName,
	WebService
} from '..';
import {
	ENGAGEMENT_SOURCE_LOCATION,
	FeaturedItemStore,
	IFeaturedItem,
	IItemFavorite,
	ILineItem,
	IMenuItem,
	IRecentItem,
	ItemFavoriteStore,
	MenuStore,
	OrderStore,
	TicketsStore,
	TMaybeItemFavorite
} from '../store';

export interface IItemBoxItem {
	description?: string;
	imgSrc?: string | null;
	labels?: TItemLabelName[];
	name: string;
	subtitle?: string | null;
	subtitleClasses?: string[];
	favoriteId?: string;
	featuredId?: string;
	sharedFavoriteId?: string;
}

export type ICustomerItemListItem = {
	customerItemId: string;
	menuItem: IMenuItem;
} | {
	customerItemId: string;
	itemBoxItem: IItemBoxItem;
};

export interface ICustomerItemMenuTileConfig {
	lineItem: ILineItem | null;
	itemBoxItem: IItemBoxItem;
}

export class CustomerItemUtils {
	public static getItemBoxItemFromLineItem(lineItem: ILineItem): IItemBoxItem {
		let itemImage: string | null = null;
		let favorite: TMaybeItemFavorite = null;
		let featured: IFeaturedItem | null = null;
		

		if(ItemService.isEngagementSource(lineItem.engagementSource)) {
			if(ItemService.engagementSourceIsFavorite(lineItem.engagementSource)) {
				favorite = ItemFavoriteStore.favorite(lineItem.engagementSource.id);
			} else if(ItemService.engagementSourceIsFeatured(lineItem.engagementSource)) {
				featured = FeaturedItemStore.featuredItem(lineItem.engagementSource.id);
			}
		}

		if(favorite?.type === ITEM_FAVORITE_TYPE.SHARED) {
			// If this is a shared favorite we might have a favorite we created from it,
			// we want to set the favoriteId so we don't have to look it up
			const tempFavorite = ItemFavoriteStore.favoriteByCreatedFromId(favorite.id);
			if(tempFavorite) {
				favorite = ItemFavoriteStore.favorite(tempFavorite.id);
			}
		}

		const sharedFavoriteId = favorite?.type === ITEM_FAVORITE_TYPE.SHARED ? favorite.id : undefined;

		if(featured && featured.image !== null) {
			itemImage = WebService.assetPath(featured.image);
		} else if(lineItem.containerImage) {
			itemImage = WebService.assetPath(lineItem.containerImage);
		} else if(lineItem.mobileImage) {
			itemImage = WebService.assetPath(lineItem.mobileImage);
		}

		const name = DisplayUtils.getLineItemDisplayName(lineItem);

		return {
			imgSrc: itemImage,
			name: name,
			subtitle: name !== lineItem.name ? lineItem.name : null,
			description: TicketsStore.ticketDisplayLineItemOptionsString(lineItem.options, true),
			favoriteId: favorite?.id,
			sharedFavoriteId: sharedFavoriteId,
		};
	}

	public static getItemBoxItem(item: IRecentItem | IItemFavorite): ICustomerItemMenuTileConfig {
		let menuItem = null;
		let lineItem = null;

		// We are introducing logic to "downgrade" a container item to a non-container item
		// Therefore, we may end up wanting a different menu item than what is passed in
		// Try and get a lineItem first
		try {
			lineItem = OrderStore.fullItemFromId(item.itemId, item.itemHqId, item.options);
			menuItem = MenuStore.item(lineItem?.itemId || null, lineItem?.itemHqId);
		} catch(error) {
			menuItem = MenuStore.item(item.itemId, item.itemHqId);
		}

		if(menuItem && !menuItem.outOfStock) {
			if(lineItem === null) { // no upgrade/downgrade path exists
				lineItem = OrderStore.fullItemFromId(item.itemId, item.itemHqId, item.options);
			}

			if(lineItem) {
				const favorite = 'shareUrl' in item ? item : null;

				if(favorite !== null) {
					lineItem.engagementSource = ItemService.lineItemEngagementSourceFromCustomerItemFavorite(favorite, ENGAGEMENT_SOURCE_LOCATION.FAVORITE);
				} else {
					lineItem.engagementSource = ItemService.lineItemEngagementSourceFromRecentItem(item as IRecentItem, ENGAGEMENT_SOURCE_LOCATION.RECENT);
				}

				return {
					itemBoxItem: CustomerItemUtils.getItemBoxItemFromLineItem(lineItem),
					lineItem: lineItem
				};
			}
		}
		return {
			itemBoxItem: {
				name: item.name,
				description: 'Currently Unavailable'
			},
			lineItem: null
		};
	}
}
